import type { TFunction } from 'i18next';
import type { UserDetailResponse } from '../api/generated';
import {
  LOCATION_ROLE_LABEL_KEYS,
  sortRoles,
  type LocationRole
} from '../constants/locationRoles';
import { readRoles } from './locationUserService';

// Every distinct role the user holds, across all their locations, narrowest
// first. The users table has one row per user and no room for a column per
// location, so it summarises WHAT they are rather than where — the per-location
// detail is in the edit form.
export const getDistinctUserRoles = (user: UserDetailResponse): LocationRole[] =>
  sortRoles(user.roleAssignments.flatMap((assignment) => readRoles(assignment.roles)));

// Falls back to a dash, not an empty cell, so "assigned nowhere" reads as an
// answer rather than as a missing value.
export const formatUserRoles = (t: TFunction, user: UserDetailResponse): string => {
  const roles = getDistinctUserRoles(user);
  if (roles.length === 0) return t('config-user-roles-none');
  return roles.map((role) => t(LOCATION_ROLE_LABEL_KEYS[role])).join(', ');
};
